// extracted by mini-css-extract-plugin
module.exports = {"switchAccountItem":"styles_switchAccountItem__28QTe","selected":"styles_selected__1-s9_"};